import React, { useState } from 'react';
import { API_BASE } from '../config';

export default function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const token = new URLSearchParams(window.location.search).get('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    const resp = await fetch(`${API_BASE}/auth/reset-password`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token, password }),
    });
    const data = await resp.json();
    if (resp.ok) setDone(true);
    else setError(data.error || 'Something went wrong.');
  };

  if (!token) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)' }}>
      <p style={{ color: 'var(--text-dim)' }}>Invalid reset link.</p>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)' }}>
      <div style={{ background: 'var(--panel)', padding: '32px', borderRadius: '12px', border: '1px solid var(--panel-border)', maxWidth: '360px', width: '100%' }}>
        <h2 style={{ color: 'var(--accent)', fontSize: '1.1rem', marginBottom: '16px' }}>🔑 New Password</h2>
        {done ? (
          <div>
            <p style={{ color: '#2ecc71', fontSize: '0.8rem' }}>✅ Password reset! You can now log in.</p>
            <a href="/login" style={{ display: 'block', marginTop: '12px', textAlign: 'center', color: 'var(--accent)', fontSize: '0.8rem' }}>Go to Login →</a>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <input type="password" placeholder="New password" value={password} onChange={e => setPassword(e.target.value)} required style={{ width: '100%', padding: '10px', marginBottom: '12px', background: 'var(--bg)', border: '1px solid var(--panel-border)', borderRadius: '6px', color: 'var(--text)', fontSize: '0.8rem', boxSizing: 'border-box' }} />
            <input type="password" placeholder="Confirm password" value={confirm} onChange={e => setConfirm(e.target.value)} required style={{ width: '100%', padding: '10px', marginBottom: '12px', background: 'var(--bg)', border: '1px solid var(--panel-border)', borderRadius: '6px', color: 'var(--text)', fontSize: '0.8rem', boxSizing: 'border-box' }} />
            {error && <p style={{ color: '#ff4444', fontSize: '0.7rem', marginBottom: '8px' }}>{error}</p>}
            <button type="submit" style={{ width: '100%', padding: '10px', background: 'var(--accent)', color: '#000', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>Reset Password</button>
          </form>
        )}
      </div>
    </div>
  );
}
